<template>
  <div v-if="field_visible" v-html="field.params.html" :class="theClass"></div>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";

export default {
  name: "StatichtmlWidget",
  mixins: [FormWidgetMixin],
  computed: {
    theClass() {
      if (!this.design) {
        return "minHeight";
      }

      return this.$attrs["class"];
    },
  },
};
</script>
<style>
.minHeight {
  min-height: 40px;
}
</style>
